import * as api from '@api/organization';
import { actions } from './organizations.slice';
import { call, takeLatest } from 'redux-saga/effects';
import { OrganizationsFetchAction } from './organizations.types';
import { Resp, dispatch } from '../helpers';
import { OrganizationType } from '@dynamika-shared/types/inventory';

const sortOrgByName = (data: OrganizationType[]): OrganizationType[] => {
  return data.sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });
};

export function* organizationsWorker(action: OrganizationsFetchAction) {
  const { name, page = 0 } = action.payload;
  try {
    const response: Resp<typeof api.fetchOrganizationList> = yield call(
      api.fetchOrganizationList,
      { page, name }
    );
    const {
      data: { content, totalPages },
    } = response;
    yield dispatch(
      actions.fetchOrganizationsSuccess({
        currentPage: page,
        institutions: content,
        totalPages,
      })
    );
  } catch (error) {
    yield dispatch(actions.fetchOrganizationsFailure(error as Error));
  }
}

export function* organizationsAllWorker() {
  try {
    const response: Resp<typeof api.fetchAllOrganizationList> = yield call(
      api.fetchAllOrganizationList
    );
    const { data } = response;

    const sortedData: OrganizationType[] = yield call(sortOrgByName, data);
    yield dispatch(actions.fetchAllOrganizationsSuccess(sortedData));
  } catch (error) {
    yield dispatch(actions.fetchAllOrganizationsFailure(error as Error));
  }
}

export function* organizationsSaga() {
  yield takeLatest(actions.fetchOrganizations.type, organizationsWorker);
  yield takeLatest(actions.fetchAllOrganizations.type, organizationsAllWorker);
}
